import React from 'react';

const EditCampaignModal = ({ 
  showEditModal, 
  setShowEditModal, 
  editingCampaign, 
  setEditingCampaign, 
  editForm, 
  setEditForm, 
  saveCampaignEdit, 
  savingEdit 
}) => {
  if (!showEditModal || !editingCampaign) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-900">Edit Campaign</h3>
          <button onClick={() => { setShowEditModal(false); setEditingCampaign(null); }} className="text-gray-400 hover:text-gray-600 text-2xl">×</button>
        </div>
        
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Campaign Title</label>
            <input
              type="text"
              value={editForm.title || ''}
              onChange={(e) => setEditForm({...editForm, title: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Goal Amount ($)</label>
            <input
              type="number"
              value={editForm.goal_amount || ''}
              onChange={(e) => setEditForm({...editForm, goal_amount: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
            <textarea
              value={editForm.description || ''}
              onChange={(e) => setEditForm({...editForm, description: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
              rows={3}
            />
          </div>
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              checked={editForm.employer_match_enabled || false}
              onChange={(e) => setEditForm({...editForm, employer_match_enabled: e.target.checked})}
              className="w-4 h-4"
            />
            <label className="text-sm font-medium text-gray-700">Enable Employer Matching</label>
          </div>
          {editForm.employer_match_enabled && (
            <div className="grid grid-cols-2 gap-4 pl-7">
              <div>
                <label className="block text-xs text-gray-500 mb-1">Match Ratio</label>
                <select
                  value={editForm.employer_match_ratio || 1}
                  onChange={(e) => setEditForm({...editForm, employer_match_ratio: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg text-sm"
                >
                  <option value="0.5">0.5:1</option>
                  <option value="1">1:1</option>
                  <option value="2">2:1</option>
                </select>
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1">Cap per Employee ($)</label>
                <input
                  type="number"
                  value={editForm.employer_match_cap_per_employee || ''}
                  onChange={(e) => setEditForm({...editForm, employer_match_cap_per_employee: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg text-sm"
                />
              </div>
            </div>
          )}
        </div>
        
        <div className="flex gap-3 mt-6">
          <button
            onClick={() => { setShowEditModal(false); setEditingCampaign(null); }}
            className="flex-1 py-3 border rounded-xl font-medium text-gray-600 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={saveCampaignEdit}
            disabled={savingEdit}
            className="flex-1 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 disabled:opacity-50"
          >
            {savingEdit ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCampaignModal;
